// extracted by mini-css-extract-plugin
export default {"modalTitle":"styles_modalTitle__g7BKz","confirmContainer":"styles_confirmContainer__VFkEM","text":"styles_text__VM9mx","buttonsContainer":"styles_buttonsContainer__d0mhf"};